import { useState } from "react";
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { GetLanguageString } from "../../helper/Components";
import FinanceAccountCategories from "./financeAccountCategories/FinanceAccountCategories";
import FinanceAccountCategoryTypes from "./financeAccountCategoryTypes/FinanceAccountCategoryTypes";
import FinanceCategories from "./financeCategories/FinanceCategories";

const FinanceTab = ({ activeTab }) => {
  const [activeInnerTab, setActiveInnerTab] = useState("financeAccountCategoryTypes");

  const tabs = [
    // {
    //   id: "infaqHeads",
    //   label: "finance_tab_infaq_heads",
    //   component: <InfaqHeads activeTab={activeInnerTab} />,
    // },
    // {
    //   id: "expenseHeads",
    //   label: "finance_tab_expense_heads",
    //   component: <ExpenseHeads activeTab={activeInnerTab} />,
    // },
    {
      id: "financeAccountCategoryTypes",
      label: "finance_tab_finance_account_category_types",
      component: <FinanceAccountCategoryTypes activeTab={activeInnerTab} />,
    },
    {
      id: "financeCategories",
      label: "finance_tab_finance_categories",
      component: <FinanceCategories activeTab={activeInnerTab} />,
    },
    {
      id: "financeAccountCategories",
      label: "finance_tab_finance_account_categories",
      component: <FinanceAccountCategories activeTab={activeInnerTab} />,
    },
  ];
  const toggleTab = (tab) => {
    if (activeInnerTab !== tab) setActiveInnerTab(tab);
  };

  return (
    <Row>
      {activeTab === "finance" ? (
        <Col md="12">
          <div className="tabs-container">
            <Nav tabs>
              {tabs.map((tab) => (
                <NavItem key={tab.id}>
                  <NavLink
                    className={activeInnerTab === tab.id ? "active" : ""}
                    onClick={() => toggleTab(tab.id)}
                  >
                    <GetLanguageString props={tab.label} />
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <TabContent activeTab={activeInnerTab}>
              {tabs.map((tab) => (
                <TabPane key={tab.id} tabId={tab.id}>
                  <div className="panel-body">{tab.component}</div>
                </TabPane>
              ))}
            </TabContent>
          </div>
        </Col>
      ) : null}
    </Row>
  );
};

export default FinanceTab;
